export const MODE = {
  ZIPCODE: 'ZIPCODE',
  SEARCH: 'SEARCH',
  SELECTED: 'SELECTED',
};

export const LIST = {
  ROW_HEIGHT: 62,
  LIST_HEIGHT: 250,
};
